import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Actions, ofType } from '@ngrx/effects';
import { BehaviorSubject, tap } from 'rxjs';
import { objectChanged } from 'src/app/core/state/core.actions';

interface OpenState {
  componentId: string;
}

@Injectable({
  providedIn: 'root',
})
export class QueryHintOverlayService {
  private openSubject = new BehaviorSubject<OpenState | null>(null);
  readonly currentlyOpen$ = this.openSubject.asObservable();

  private actions$ = inject(Actions);
  private destroyRef = inject(DestroyRef);

  constructor() {
    this.actions$
      .pipe(
        ofType(objectChanged),
        tap(() => {
          this.forceClose();
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  open(componentId: string) {
    this.openSubject.next({ componentId });
  }

  closeIfOwner(componentId: string) {
    const current = this.openSubject.value;
    if (current?.componentId === componentId) {
      this.openSubject.next(null);
    }
  }

  forceClose() {
    this.openSubject.next(null);
  }

  toggle(componentId: string) {
    const current = this.openSubject.value;

    if (current?.componentId === componentId) {
      this.closeIfOwner(componentId);
    } else {
      this.open(componentId);
    }
  }

  get isOpen(): OpenState | null {
    return this.openSubject.value;
  }
}
